/**
 * 查询条件类型
 */
export var QueryConditionType;
(function (QueryConditionType) {
    /** 必须包含所有指定组件 */
    QueryConditionType["ALL"] = "all";
    /** 必须包含任意一个指定组件 */
    QueryConditionType["ANY"] = "any";
    /** 不能包含任何指定组件 */
    QueryConditionType["NONE"] = "none";
})(QueryConditionType || (QueryConditionType = {}));
//# sourceMappingURL=QueryTypes.js.map